'use strict';

var React = require('react');
var reactDom = require('react-dom');
var isClient = require('../utils/isClient');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var isClient__default = /*#__PURE__*/_interopDefaultLegacy(isClient);

const PortalContext = React.createContext(isClient__default['default'] ? document.body : null);
const Portal = React.forwardRef(({ children, ariaRole, ariaLabel }, ref) => {
    const context = React.useContext(PortalContext);
    const [container] = React.useState(() => {
        if (isClient__default['default']) {
            const div = document.createElement('div');
            const myRef = ref;
            myRef.current = div;
            return div;
        }
        return null;
    });
    React.useLayoutEffect(() => {
        if (!container || !context)
            return undefined;
        if (ariaRole)
            container.setAttribute('role', ariaRole);
        if (ariaLabel)
            container.setAttribute('aria-label', ariaLabel);
        context.appendChild(container);
        return () => {
            context.removeChild(container);
        };
    }, [container, context]);
    if (container) {
        const portal = reactDom.createPortal(children, container);
        return React__default['default'].createElement(PortalContext.Provider, { value: container }, portal);
    }
    // not Client
    return null;
});

module.exports = Portal;
